import { createStore } from 'jotai';
export const editorStore: any = createStore();
